export const SYSTEM_PATH = "/apps/system";

export const FEATURE_TOGGLES_PATH = `${SYSTEM_PATH}/feature-toggles`;
export const getFeatureToggleViewPath = (id: string | number) =>
  `${FEATURE_TOGGLES_PATH}/view/${id}`;

export const ERROR_LOGS_PATH = `${SYSTEM_PATH}/error-logs`;
export const getErrorLogViewPath = (id: string | number) =>
  `${ERROR_LOGS_PATH}/view/${id}`;
